import { useCallback, useState } from 'react';

import { hashResource } from 'src/data/performance';
import { usePerformanceActions, useNotificationActions } from 'src/store';
import {
  AD_ACCOUNTS_SELECTION_POPUP,
  useAdAccountsSelectionPopup,
  useAddResourcePopup,
  usePopups,
} from './popup';
import * as events from 'src/lib/events';
import { useTrackingEvent } from 'src/services/useTrackingEvent';

export const useConnectToChannel = (generationTool) => {
  const notifications = useNotificationActions();
  const performanceActions = usePerformanceActions();
  const openAdAccountsSelectionPopup = useAdAccountsSelectionPopup();
  const openAddResourcePopup = useAddResourcePopup();
  const trackingEvent = useTrackingEvent();
  const popups = usePopups();

  const [connecting, setConnecting] = useState();

  const addResource = useCallback(
    async (onChange) => {
      setConnecting(true);
      try {
        const result = await openAddResourcePopup();
        if (!result) {
          return;
        }
        onChange(
          hashResource({
            channel: result.channel,
            id: result.id,
            name: result?.urls?.length ? result?.urls[0] : result.name,
          })
        );
      } finally {
        setConnecting(false);
      }
    },
    [openAddResourcePopup]
  );

  const connectToChannel = useCallback(
    async (channel) => {
      if (performanceActions.isChannelConnected(channel)) {
        await openAdAccountsSelectionPopup({ channel });
        return;
      }

      trackingEvent(events.PROJECT.clickedTalkingPointConnectToChannel, {
        page: events.EVENT_PAGE.editor,
        generationTool,
      });

      setConnecting(true);
      performanceActions
        .connectToChannel(channel)
        .catch((error) => {
          popups.closePopup(AD_ACCOUNTS_SELECTION_POPUP);
          notifications.displayError(error);
        })
        .finally(() => {
          setConnecting(false);
        });
      openAdAccountsSelectionPopup({ channel });
    },
    [
      openAdAccountsSelectionPopup,
      performanceActions,
      notifications,
      trackingEvent,
      generationTool,
      popups,
    ]
  );

  return {
    connectToChannel,
    connecting,
    addResource,
  };
};
